"use client"

import { useEffect, useState } from "react"
import { Link } from "react-router-dom"
import { encryptId } from "../../utils/crypto";

export default function RecentProjects() {
  const [projects, setProjects] = useState([])

  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await fetch("http://localhost:5000/clients-projects");
        const data = await response.json();
        setProjects(data);
      } catch (error) {
        console.error("Error fetching projects:", error);
      }
    };
    fetchData();
  }, []);

  const getStatusStyle = (status) => {
    switch (status) {
      case 'completed': return { bg: 'rgba(16, 185, 129, 0.1)', color: '#34d399', border: 'rgba(16, 185, 129, 0.2)' };
      case 'assigned': return { bg: 'rgba(59, 130, 246, 0.1)', color: '#60a5fa', border: 'rgba(59, 130, 246, 0.2)' };
      case 'unassigned': return { bg: 'rgba(245, 158, 11, 0.1)', color: '#fbbf24', border: 'rgba(245, 158, 11, 0.2)' };
      case 'cancelled': return { bg: 'rgba(248, 113, 113, 0.1)', color: '#f87171', border: 'rgba(248, 113, 113, 0.2)' };
      default: return { bg: 'rgba(156, 163, 175, 0.1)', color: '#9ca3af', border: 'rgba(156, 163, 175, 0.2)' };
    }
  };

  return (
    <div style={{ overflow: 'hidden' }}>
      <div style={{ display: 'flex', flexDirection: 'column', gap: '4px' }}>
        {projects.map((project) => {
          const ss = getStatusStyle(project.status);
          return (
            <Link
              key={project.client_project_id}
              to={`/ProjectMap/${encodeURIComponent(encryptId(project.client_project_id))}`}
              style={{ textDecoration: 'none' }}
            >
              <div
                style={{
                  padding: '14px 16px',
                  borderRadius: '12px',
                  transition: 'all 0.2s ease',
                  cursor: 'pointer',
                }}
                onMouseEnter={e => e.currentTarget.style.background = 'var(--bg-glass)'}
                onMouseLeave={e => e.currentTarget.style.background = 'transparent'}
              >
                <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start' }}>
                  <div style={{ flex: 1, minWidth: 0 }}>
                    <p style={{
                      fontSize: '0.85rem',
                      fontWeight: 600,
                      color: 'var(--text-primary)',
                      marginBottom: '3px',
                      overflow: 'hidden',
                      textOverflow: 'ellipsis',
                      whiteSpace: 'nowrap',
                    }}>{project.title}</p>
                    <p style={{
                      fontSize: '0.75rem',
                      color: 'var(--text-muted)',
                      overflow: 'hidden',
                      textOverflow: 'ellipsis',
                      whiteSpace: 'nowrap',
                    }}>{project.client_name}</p>
                  </div>
                  <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'flex-end', marginLeft: '12px', flexShrink: 0 }}>
                    <span style={{
                      padding: '2px 10px',
                      borderRadius: '9999px',
                      background: ss.bg,
                      border: `1px solid ${ss.border}`,
                      fontSize: '0.65rem',
                      fontWeight: 600,
                      color: ss.color,
                      textTransform: 'capitalize',
                    }}>{project.status}</span>
                    <span style={{
                      marginTop: '4px',
                      fontSize: '0.65rem',
                      color: 'var(--text-muted)',
                    }}>
                      {new Date(project.updated_at).toLocaleDateString()}
                    </span>
                  </div>
                </div>
              </div>
            </Link>
          );
        })}
      </div>
    </div>
  );
}
